module.exports = __webpack_public_path__ + "img/logo.c3b02bc4.svg";